import { render, staticRenderFns } from "./ReactionsInPlayer.vue?vue&type=template&id=45cf5364&scoped=true&"
import script from "./ReactionsInPlayer.vue?vue&type=script&lang=js&"
export * from "./ReactionsInPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsInPlayer.vue?vue&type=style&index=0&id=45cf5364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf5364",
  null
  
)

export default component.exports